module.exports = __webpack_public_path__ + "static/img/historical-marker.74a9816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/historical-marker.jpg
// module id = 409
// module chunks = 0